<template>
  <div class="csb-layout">
    <nav class="csb-sidebar">
      <ul class="csb-nav">
        <li><button class="button-71" :class="{ selected: selectedSection === 'pendientes' }" @click="selectSection('pendientes')">Items Pendientes</button></li>
        <li><button class="button-71" :class="{ selected: selectedSection === 'entregados' }" @click="selectSection('entregados')">Items Entregados</button></li>
        <li><button class="button-71" :class="{ selected: selectedSection === 'historicos' }" @click="selectSection('historicos')">Items Históricos</button></li>
        <li v-if="puedeEscribir"><router-link to="/csb/nuevo-item" class="button-71" style="margin-bottom:1em;display:inline-block;">Agregar Nuevo Item</router-link></li>
      </ul>
      <div class="csb-legend">
        <div class="legend-row status-terminado"><span>0:</span> terminado</div>
        <div class="legend-row status-normal"><span>1:</span> normal</div>
        <div class="legend-row status-warning"><span>2:</span> warning</div>
        <div class="legend-row status-alert"><span>3:</span> alert</div>
        <div class="legend-row status-sea"><span>4:</span> @ sea</div>
        <div class="legend-row status-scl"><span>5:</span> @ SCL</div>
        <div class="legend-row status-puq"><span>6:</span> @ PUQ</div>
        <div class="legend-row status-pmc"><span>7:</span> @ PMC</div>
        <div class="legend-row status-paid"><span>8:</span> paid</div>
        <div class="legend-row status-santatecla"><span>9:</span> @ Santa Tecla</div>
      </div>
    </nav>
    <div class="csb-content">
      <div v-if="loading">Cargando...</div>
      <div v-else-if="error">Error: {{ error }}</div>
      <div v-else>
        <!-- Filtros -->
        <div style="margin-bottom:1em; display: flex; gap: 1em; align-items: center;">
          <input v-model="filtroBuque" placeholder="Filtrar por Buque" style="padding:0.4em; min-width: 180px;" />
          <input v-model="filtroProveedor" placeholder="Filtrar por Proveedor" style="padding:0.4em; min-width: 180px;" />
          <button class="button-71" @click="limpiarFiltros" style="width:auto;">Limpiar</button>
        </div>
        <table v-if="itemsFiltrados.length">
          <thead>
            <tr>
              <!-- <th @click="headerClick(8)" class="clickable-header white-header">Status</th> -->
              <th @click="headerClick(1)" class="clickable-header white-header">Buque</th>
              <th>Descripcion</th>
              <th>Detalle</th>
              <th>Docs.</th>
              <th @click="headerClick(2)" class="clickable-header white-header same-width">Proveedor</th>
              <th class="same-width">Cotización</th>
              <th class="same-width">Factura</th>
              <th @click="headerClick(7)" class="clickable-header white-header same-width">Fecha RFQ</th>
              <!-- <th @click="headerClick(3)" class="clickable-header white-header">Container</th> -->
              <!-- <th @click="headerClick(4)" class="clickable-header white-header">BL o AWB</th> -->
              <!-- <th @click="headerClick(5)" class="clickable-header white-header">Carrier</th> -->
              <th @click="headerClick(6)" class="clickable-header white-header">Origen</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in itemsFiltrados" :key="idx" :class="rowClass(item)">
              <!-- <td>{{ item.item_status }}</td> -->
              <td>{{ item.item_buque }}</td>
              <td>{{ item.item_descripcion }}</td>
              <td>{{ item.si_status }}</td>
              <td>{{ item.sd_status }}</td>
              <td class="same-width">{{ item.item_proveedor }}</td>
              <td class="same-width">{{ item.item_cotizacion }}</td>
              <td class="same-width">{{ item.item_factura }}</td>
              <td class="same-width">{{ item.item_fecha_rfq }}</td>
              <!-- <td>{{ item.item_container }}</td> -->
              <!-- <td>{{ item.item_bl_awb }}</td> -->
              <!-- <td>{{ item.item_carrier }}</td> -->
              <td>{{ item.item_origen }}</td>
              <td>
                <button v-if="puedeEscribir" class="button-71" @click="editItem(item)">Editar</button>
                <button v-if="puedeEscribir" class="button-71" style="margin-left:0.5em;background:#22c55e;" @click="openDetalleModal(item)">Agregar Detalle</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>No hay datos para mostrar.</div>
      </div>
    </div>

    <!-- Detalle Modal -->
    <div v-if="detalleModalVisible" class="modal-overlay">
      <div class="modal-content">
        <h3>Agregar Detalle a Item</h3>
        <div style="margin-bottom:1em;">
          <label>
            <input type="radio" value="item" v-model="detalleTipo"> Detalle de Item
          </label>
          <label style="margin-left:1em;">
            <input type="radio" value="docs" v-model="detalleTipo"> Detalle de Docs
          </label>
        </div>
        <input type="date" v-model="detalleFecha" style="width:100%;margin-bottom:1em;" />
        <textarea v-model="detalleTexto" rows="4" style="width:100%;margin-bottom:1em;" placeholder="Ingrese el detalle..."></textarea>
        <div v-if="detalleError" style="color:red;margin-bottom:1em;">{{ detalleError }}</div>
        <div style="text-align:right;">
          <button class="button-71" @click="guardarDetalle" style="background:#22c55e;">Guardar</button>
          <button class="button-71" @click="closeDetalleModal" style="margin-left:0.5em;">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '../../api/index';

export default {
  name: 'CSBIndex',
  data() {
    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().slice(0, 10);
    return {
      items: [],
      loading: false,
      error: null,
      selectedSection: 'pendientes',
      detalleModalVisible: false,
      detalleItem: null,
      detalleTexto: '',
      detalleTipo: 'item', // 'item' o 'docs'
      detalleFecha: today,
      detalleError: '',
      filtroBuque: '',
      filtroProveedor: '',
    };
  },
  computed: {
    puedeEscribir() {
      return this.$store.getters['auth/puede']('csb.items', 'escribir');
    },
    itemsFiltrados() {
      return this.items.filter(item => {
        const buqueOk = this.filtroBuque.trim() === '' || (item.item_buque || '').toLowerCase().includes(this.filtroBuque.trim().toLowerCase());
        const proveedorOk = this.filtroProveedor.trim() === '' || (item.item_proveedor || '').toLowerCase().includes(this.filtroProveedor.trim().toLowerCase());
        return buqueOk && proveedorOk;
      });
    },
  },
  methods: {
    async fetchItemsPendientes() {
      this.loading = true;
      this.error = null;
      try {
        const res = await apiClient.get('/csb/items-pendientes');
        this.items = res.data;
      } catch (e) {
        this.error = 'No se pudieron cargar los items pendientes';
      } finally {
        this.loading = false;
      }
    },
    async fetchItemsStatus(status = 1) {
      this.loading = true;
      this.error = null;
      try {
        const res = await apiClient.get(`/csb/items-status/${status}`);
        this.items = res.data;
      } catch (e) {
        this.error = 'No se pudieron cargar los items entregados';
      } finally {
        this.loading = false;
      }
    },
    async fetchItemsHistoricos() {
      this.loading = true;
      this.error = null;
      try {
        const res = await apiClient.get('/csb/items-historicos');
        this.items = res.data;
      } catch (e) {
        this.error = 'No se pudieron cargar los items históricos';
      } finally {
        this.loading = false;
      }
    },
    rowClass(item) {
      switch (item.item_status) {
        case 0: return 'status-terminado';
        case 1: return 'status-normal';
        case 2: return 'status-warning';
        case 3: return 'status-alert';
        case 4: return 'status-sea';
        case 5: return 'status-scl';
        case 6: return 'status-puq';
        case 7: return 'status-pmc';
        case 8: return 'status-paid';
        case 9: return 'status-santatecla';
        default: return '';
      }
    },
    selectSection(section) {
      this.selectedSection = section;
      if (section === 'pendientes') this.fetchItemsPendientes();
      else if (section === 'entregados') this.fetchItemsStatus(1);
      else if (section === 'historicos') this.fetchItemsHistoricos();
    },
    headerClick(num) {
      // Only trigger for Items Pendientes section
      if (this.selectedSection === 'pendientes') {
        this.loading = true;
        this.error = null;
        apiClient.get(`/csb/items-pendientes-order/${num}`)
          .then(res => {
            this.items = res.data;
            this.selectedSection = 'pendientes';
          })
          .catch(() => {
            this.error = 'No se pudieron cargar los items pendientes ordenados';
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    editItem(item) {
      // Example: route to edit page (implement the route and EditItem.vue as needed)
      this.$router.push({ name: 'EditarItem', params: { item_id: item.item_id } });
    },
    openDetalleModal(item) {
      this.detalleItem = item;
      this.detalleTexto = '';
      this.detalleTipo = 'item';
      this.detalleError = '';
      this.detalleModalVisible = true;
      // Set default date to today
      this.detalleFecha = new Date().toISOString().slice(0, 10);
    },
    closeDetalleModal() {
      this.detalleModalVisible = false;
      this.detalleItem = null;
      this.detalleTexto = '';
      this.detalleError = '';
      this.detalleFecha = new Date().toISOString().slice(0, 10);
    },
    async guardarDetalle() {
      this.detalleError = '';
      if (!this.detalleTexto.trim()) {
        this.detalleError = 'El detalle es obligatorio.';
        return;
      }
      const fecha = this.detalleFecha || new Date().toISOString().slice(0, 10);
      let payload;
      let endpoint;
      if (this.detalleTipo === 'item') {
        endpoint = '/csb/status_item';
        payload = {
          item_id: this.detalleItem.item_id,
          si_fecha: fecha,
          si_status: this.detalleTexto,
          si_destino: '-'
        };
      } else {
        endpoint = '/csb/status_docs';
        payload = {
          item_id: this.detalleItem.item_id,
          sd_fecha: fecha,
          sd_status: this.detalleTexto,
          sd_destino: '-'
        };
      }
      try {
        await apiClient.post(endpoint, payload);
        this.detalleError = '';
        this.closeDetalleModal();
        // Siempre recarga la tabla para asegurar actualización
        await this.fetchItemsPendientes();
        this.selectedSection = 'pendientes';
      } catch (e) {
        if (e.response && e.response.data && e.response.data.detail) {
          this.detalleError = e.response.data.detail;
        } else if (e.message) {
          this.detalleError = e.message;
        } else {
          this.detalleError = 'Error al guardar el detalle';
        }
        // No cerrar el modal si hay error
      }
    },
    limpiarFiltros() {
      this.filtroBuque = '';
      this.filtroProveedor = '';
    },
  },
  mounted() {
    this.selectedSection = 'pendientes';
    this.fetchItemsPendientes();
  },
  beforeUnmount() {
    // Removed toggle-sidebar emit
  },
};
</script>

<style scoped>
.csb-layout {
  display: flex;
  min-height: 100vh;
}
.csb-sidebar {
  width: 260px;
  min-width: 220px;
  background: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 1em 1em 1em;
  gap: 2em;
  height: 100vh;
  box-sizing: border-box;
}
.csb-legend {
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  width: 100%;
}
.legend-row {
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.2em 0.7em;
  border-radius: 5px;
  font-size: 0.97em;
  font-family: inherit;
  font-weight: 500;
  width: 100%;
}
.status-terminado { background-color: #e0e0e0 !important; color: #888 !important; }
.status-normal { background-color: #fff !important; color: #222; border: 1px solid #ddd; }
.status-warning { background-color: #fffbe6 !important; color: #b59f00; }
.status-alert { background-color: #ffe6e6 !important; color: #c00; }
.status-sea { background-color: #e6f0ff !important; color: #0078d4; }
.status-scl { background-color: #f5e6d0 !important; color: #a67c52; }
.status-puq { background-color: #a67c52 !important; color: #fff; }
.status-pmc { background-color: #444 !important; color: #fff; }
.status-paid { background-color: #e6ffed !important; color: #22c55e; }
.status-santatecla { background-color: #e6e6fa !important; color: #7c3aed; }
.csb-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.csb-nav li {
  display: block;
  width: 100%;
}
.csb-content {
  margin-top: 1rem;
  flex: 1;
  padding: 2em 2em 2em 2em;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.92em;
}
thead {
  background-color: #333;
  color: #fff;
}
tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}
tbody tr:nth-child(even) {
  background-color: #fff;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 0.92em;
}
th {
  font-weight: bold;
}
.status-pendiente {
  background-color: #fffbe6 !important;
}
.status-entregado {
  background-color: #e6ffed !important;
}
.status-historico {
  background-color: #e6f0ff !important;
}
.button-71 {
  background-color: #0078d4;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 0.5px 1.5px rgba(0,0,0,0.08);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7em 1.5em;
  margin: 0.2em 0;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  outline: none;
  width: 100%;
  text-align: left;
  width:12em;
}
.button-71.selected {
  background-color: #22c55e !important;
  color: #fff;
  box-shadow: 0 4px 12px rgba(34,197,94,0.15);
  transform: scale(1.0);
}
.button-71:hover, .button-71:focus {
  background-color: #005fa3;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12), 0 1.5px 3px rgba(0,0,0,0.12);
  transform: translateY(-2px) scale(1.03);
}
.button-71:active {
  background-color: #004c87;
  box-shadow: 0 1px 2px rgba(0,0,0,0.10);
  transform: none;
}
.clickable-header {
  cursor: pointer;
  text-decoration: underline;
  color: #0078d4;
  transition: color 0.2s;
}
.clickable-header:hover {
  color: #22c55e;
}
.white-header {
  color: #fff !important;
}
.same-width {
  width: 8em;
  min-width: 8em;
  max-width: 8em;
  text-align: left;
}
.detalle-modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: #fff;
  padding: 2em 2em 1.5em 2em;
  border-radius: 10px;
  min-width: 320px;
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  margin-top: 1em;
}
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
</style>
